<mat-error [id]="errorId" class="error">
  <xpo-icon iconName="error"></xpo-icon>
  <ng-content></ng-content>
</mat-error>
